<template>
  <div>
    <main>
      <v-content>
        <v-container fluid>
          <v-layout column align-center>
            <div class="display-3 grey--text mb-5">
              {{ title }}
            </div>
            <img src="img/gurbani_logo.png" alt="Vuetify.js" >
          </v-layout>
        </v-container>
      </v-content>
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'welcome-view',

  metaInfo () {
    return { title: this.$t('home') }
  },

  computed: mapGetters({
    authenticated: 'authCheck'
  }),

  data: () => ({
    title: window.config.appName
  })
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/welcome.vue